import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { FiltroEditor } from "./filtro";
import { StatusCajaRutaList } from "./list";
type Entity = models.FiltroStatusCajaRuta;
export interface Props {
    value: Entity;
    onChange: (x: Entity) => void;
}

/**Muestra un listado de los status de cajas junto con el filtro */
class StatusCajaListFiltroControlled extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                <FiltroEditor {...this.props} />
                <StatusCajaRutaList {... this.props} />
            </div>
        )
    }
}

export const StatusCajaListFiltro = kea.makeUncontrolled<Props>("value", "onChange", { } )(StatusCajaListFiltroControlled) as React.ComponentClass<{}>;


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscajaruta/list/listfiltro.tsx